import { Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import EvevntService from "Lib/API/Events";
import CardImage from "assets/icons/EventInfoImg.png";
import { ContactUs } from "components/ContactUs/ContactUs";
import AlertDialog from "components/Dialog";
import ReservationTabs from "components/reservationTabs/ReservationTabs";
import { useFormik } from "formik";
import * as calculation from "helper/CalculateEvent";
import { checkIsStripe, checkIsTranzila } from "helper/checkIsStripe";
import { postalCodeFormat, postalCodeLabel } from "helper/postalCodeFormat";
import { useMobileView } from "hook/mobileView/useMobileView";
import { useSnackbar } from "notistack";
import { emailRegex } from "utils/validation";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import {
  eventsSlice,
  setCounterTicket,
  setTicketTypeList,
  setTicketTypeVariants,
} from "services/api/events";
import DonationBox from "components/DonationBox/DonationBox";
import FinanceService from "Lib/API/Finance";
import Header from "./Header/Header";
import LoginModal from "./PersonalDetailsCard/LoginModal";
import { PaymentCard } from "./PaymentCard/PaymentCard";
import { PaymentResultPage } from "./PaymentResultPage/PaymentResultPage";
import { PersonalDetailsCard } from "./PersonalDetailsCard/PersonalDetailsCard";
import { SummaryCard } from "./SummaryCard/SummaryCard";
import {
  CardContent,
  ImageCard,
  ImageContainer,
  PaymentButtonSubmit,
  Wrapper,
} from "./Theme";
import { Ticket } from "./Tickets/Ticket";
import { getAccessTokenSilently, getAuthenticated } from "utils/functions";
import { toastr } from "react-redux-toastr";
import { convenienceFeeAmount as calcConvenienceFee } from "helper/convenienceFee";

export const ReservationEventPage = () => {
  const allowInstallmentsOrganization =
    localStorage.getItem("allowInstallments") === "true";
  const recaptchaRef = useRef();
  const isInitialFormLoad = useRef(true);
  const isAuthenticated = getAuthenticated();
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;
  const { enqueueSnackbar } = useSnackbar();
  const { isMobile } = useMobileView();
  const addCardStripeRef = useRef(null);
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    eventData,
    numberOfTickets,
    products,
    FormDataEvent,
    totalProducts,
    ticketTypeVariants,
    ticketTypeList,
    selectedValue,
    varients,
  } = useSelector((state) => state?.Events);
  const { logoImage } = useSelector((state) => state.organization);
  const postalLabel = postalCodeLabel();
  const [isLoading, setLoading] = useState(false);
  const [isLoadingPay, setLoadingPay] = useState(false);
  const [error, setError] = useState({ value: true, message: "" });
  const [isCheckedApplay, setIsCheckedApplay] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedAchCard, setSelectedAchCard] = useState(null);
  const [newProducts, setProducts] = useState([]);
  const [activeTicket, setActiveTicket] = useState(0);
  const [confirmDeleteTicket, setConfirmDeleteTicket] = useState({
    open: false,
    ticketId: null,
    ticketIndex: null,
    isLoading: false,
  });
  const [ticketTypeTabs, setTicketTypeTabs] = useState([]);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [authTick, setAuthTick] = useState(0); // incremented after login to trigger re-render
  const [selectedEventDates, setSelectedEventDates] = useState([]);
  const [selectedVariants, setSelectedVariants] = useState([]);

  const reservationId = localStorage.getItem("reserveId");
  const logo = isAuth ? logoImage : localStorage.getItem("logoImgEvent");
  const paymentMethod = JSON.parse(localStorage.getItem("paymentMethodEvents"));
  const achPaymentMethod = JSON.parse(
    localStorage.getItem("achPaymentMethodEvents"),
  );
  const token = localStorage.getItem("token");
  const entrySource = sessionStorage.getItem("entrySource");
  const isFromApp = entrySource === "app";
  const formData = new FormData();
  const [firstRender, setFirstRender] = useState(false);
  const [checkoutDonationLedger, setCheckoutDonationLedger] = useState(null);
  const [donationAmount, setDonationAmount] = useState(0);
  const [isLoadingDonationLedger, setIsLoadingDonationLedger] = useState(true);

  const handleTotalForPay = () => {
    let totalForTickets;
    if (eventData?.multiEventsType === "individual") {
      const onRegPrice = eventData?.eventPricing?.prices?.find(
        (p) => p?.type === "onRegistration" && p?.variant
      );
      const rawVariantInfo = onRegPrice?.variantInfo || {};
      const hasMultiDateVariants = Object.values(rawVariantInfo).some((v) => v?.eventDate);

      if (hasMultiDateVariants) {
        // Sum selected variant amounts per ticket
        totalForTickets = (selectedVariants || []).reduce((sum, ticketVarMap) => {
          return sum + Object.values(ticketVarMap || {}).reduce((tSum, variantKey) => {
            if (variantKey === null || variantKey === undefined) return tSum;
            return tSum + (rawVariantInfo[variantKey]?.amount || 0);
          }, 0);
        }, 0);
      } else {
        // Fallback: selectedEventDates (array-of-arrays per ticket)
        const selectedDates = selectedEventDates || [];
        totalForTickets = selectedDates.reduce((sum, ticketDates) => {
          if (!Array.isArray(ticketDates)) return sum;
          return sum + ticketDates.reduce((tSum, dateIdx) => {
            const dateItem = eventData?.multiEventsDates?.[dateIdx];
            return tSum + (dateItem?.amount || 0);
          }, 0);
        }, 0);
      }
    } else {
      totalForTickets = calculation.calculateTotalPayment(
        eventData,
        ticketTypeVariants,
        "type",
        isAuth,
      );
    }
    return {
      total: (+totalForTickets + +totalProducts + +donationAmount).toFixed(2),
      totalcountTickets: (+totalPayforAllTickets).toFixed(2),
    };
  };
  const totalPay = handleTotalForPay();
  const makeEventFormsFullScreen =
    totalPay?.total !== "0.00" ||
    totalProducts > 0 ||
    eventData?.multiEventsType === "individual" ||
    calculation?.calculateDiscount(eventData, ticketTypeVariants, "event", isAuth)?.totalDiscount > 0;

  const [convenienceFeeByPayment, setConvenienceFeeByPayment] = useState({
    "credit-card": true,
    ach: true,
  });
  const [calcDueAmount, setCalcDueAmount] = useState(null);

  const hasInstallmentOption = useCallback(() => {
    const hasInstallmentInProducts = newProducts.some(
      (product) => product?.installmentStatus,
    );
    const hasInstallmentInTicketVariants = ticketTypeVariants?.some(
      (variant) => variant?.installmentStatus,
    );

    return hasInstallmentInProducts || hasInstallmentInTicketVariants;
  }, [newProducts, ticketTypeVariants]);
  const hasInstallment = hasInstallmentOption();

  const enableCreditCardPay = paymentMethod?.allow_member || !isAuth;
  const enableAchPay =
    achPaymentMethod?.allow_member && checkIsStripe(achPaymentMethod);
  const disabledCreditCardPay =
    hasInstallment && !paymentMethod?.allowMemberInstallment && isAuth;
  const disabledAchPay =
    (hasInstallment && !achPaymentMethod?.allowMemberInstallment) ||
    (enableAchPay && !isAuth);
  const displayAchTooltip = useMemo(
    () => (enableAchPay && !isAuth ? "Please login to pay with ACH" : ""),
    [enableAchPay, isAuth],
  );
  const enableBillMyAccount = eventData?.allowBillMyAccount || false;
  const disabledBillMyAccount = useMemo(() => hasInstallment, [hasInstallment]);

  const isInstallmentEnabled = useMemo(() => {
    if (!allowInstallmentsOrganization) {
      return false;
    }

    return isAuth
      ? paymentMethod?.allowMemberInstallment ||
          achPaymentMethod?.allowMemberInstallment
      : true;
  }, [allowInstallmentsOrganization, isAuth, paymentMethod, achPaymentMethod]);

  const initialActivePayment = useMemo(() => {
    if (isAuth) {
      if (enableCreditCardPay) return "credit-card";
      if (enableAchPay) return "ach";
      if (eventData?.allowBillMyAccount) return "bill-my-account";
      return "";
    }
    return "credit-card";
  }, [isAuth, enableCreditCardPay, enableAchPay, eventData]);

  // TODO: split formik into multiple instances for each form
  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: false,
    initialValues: {
      registrationForm: [],
      errors: [],
      ticketsData: Array.from({ length: numberOfTickets?.length }, () => [
        ...products,
      ]),
      dropdowns: [],
      accountInfo: {},
      cardsDetails: {},
      resultPage: "",
      activePayment: initialActivePayment,
    },
    validationSchema: false,
    onSubmit: async (values) => {},
  });

  const activePayment = formik?.values?.activePayment;

  useEffect(() => {
    if (initialActivePayment) {
      formik.setFieldValue("activePayment", initialActivePayment);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialActivePayment]);

  useEffect(() => {
    if (!firstRender && numberOfTickets.length > 0) {
      formik.setFieldValue(
        "ticketsData",
        Array.from({ length: numberOfTickets?.length }, () => [...products]),
      );
      setFirstRender(true);
    }
    // Grow selectedEventDates / selectedVariants when tickets are added — never reset existing selections
    setSelectedEventDates((prev) => {
      if (prev.length >= numberOfTickets.length) return prev;
      return [...prev, ...Array.from({ length: numberOfTickets.length - prev.length }, () => [])];
    });
    setSelectedVariants((prev) => {
      if (prev.length >= numberOfTickets.length) return prev;
      return [...prev, ...Array.from({ length: numberOfTickets.length - prev.length }, () => ({}))];
    });
  }, [numberOfTickets]);

  useEffect(() => {
    if (!ticketTypeList?.length || ticketTypeTabs?.length) return;
    const updatedTicketTypeTabs = ticketTypeList?.map((item) => {
      return {
        ...item,
        valid: false,
      };
    });
    setTicketTypeTabs(updatedTicketTypeTabs);
  }, [ticketTypeList]);

  const formDataReservation = formik?.values?.registrationForm || [];

  const totalPayforAllTickets = useMemo(
    () => eventData?.eventPricing?.total_to_pay * numberOfTickets.length,
    [eventData, numberOfTickets],
  );

  const totalAmountCalculation = calculation?.calculateDiscount(
    eventData,
    ticketTypeVariants,
    "event",
    isAuth,
  );

  const totalPayment = useMemo(
    () => totalAmountCalculation?.totalAfterDiscount?.replace(/,/g, ""),
    [eventData, numberOfTickets],
  );

  const totalDiscount = totalAmountCalculation?.totalDiscount;

  const thereIsFormEmpty = useMemo(
    () => formDataReservation?.some((item) => item?.formData?.length === 0),
    [formDataReservation],
  );

  // 1-based numbers of tickets with no event date picked (individual multi-date events only).
  const ticketsMissingDates = useMemo(() => {
    if (eventData?.multiEventsType !== "individual") return [];
    const onRegPrice = eventData?.eventPricing?.prices?.find(
      (p) => p?.type === "onRegistration" && p?.variant,
    );
    const byVariant = Object.values(onRegPrice?.variantInfo || {}).some((v) => v?.eventDate);
    // checkbox dates only apply when the event actually has dates to pick
    if (!byVariant && !eventData?.multiEventsDates?.length) return [];
    return numberOfTickets
      .map((_, i) =>
        (byVariant
          ? Object.values(selectedVariants?.[i] || {}).some(Boolean)
          : (selectedEventDates?.[i] || []).length > 0)
          ? null
          : i + 1,
      )
      .filter(Boolean);
  }, [eventData, numberOfTickets, selectedVariants, selectedEventDates]);

  // True when all required registration-form fields have values.
  // Used to keep the Tranzila payment overlay active until the form is ready.
  const isRegistrationFormValid = useMemo(() => {
    if (thereIsFormEmpty) return false;
    if (ticketsMissingDates.length) return false;
    const requiredFields = FormDataEvent || [];
    for (const item of formik?.values?.registrationForm || []) {
      for (const subItem of item?.formData || []) {
        const required = requiredFields.find(
          (r) => r.id === subItem.id && r.required,
        );
        if (!required) continue;
        if (!subItem.value || subItem?.value?.length === 0) return false;
        if (subItem?.name?.includes("email_input")) {
          if (!emailRegex.test(subItem.value)) return false;
        }
      }
    }
    return true;
  }, [thereIsFormEmpty, ticketsMissingDates, formik?.values?.registrationForm, FormDataEvent]);

  const getFormById = async (preserveVarients = false) => {
    if (!preserveVarients) {
      // restore selected dropdown list and varients only on initial load, not on login
      dispatch(eventsSlice.actions.resetAction([]));
      dispatch(
        eventsSlice.actions.setVarients(
          JSON.parse(localStorage.getItem("originVarients")),
        ),
      );
    }
    try {
      setLoading(true);
      const token = isAuth
        ? await getAccessTokenSilently()
        : localStorage.getItem("eventToken");
      const res = await EvevntService.getFormById(
        token,
        eventData?.form,
        localStorage.getItem("eventOrgId"),
      );
      dispatch(eventsSlice.actions.setFormReservationData(res?.task_data));
    } catch (error) {
      enqueueSnackbar(error?.data?.message, {
        variant: "error",
      });
      dispatch(eventsSlice.actions.setFormReservationData({}));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    localStorage.removeItem("redirectUrl");
    return () => {
      localStorage.setItem("registrationForm", []);
      localStorage.setItem("ApplayCheckBox", JSON.stringify(false));
    };
  }, []);

  const getCurrentPaymentMethod = useCallback(() => {
    if (formik?.values?.activePayment === "credit-card") {
      return paymentMethod;
    }
    if (formik?.values?.activePayment === "ach") {
      return achPaymentMethod;
    }
    return null;
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const currentPaymentMethod = useMemo(() => getCurrentPaymentMethod(), [
    getCurrentPaymentMethod,
  ]);
  const isStripe = useMemo(() => checkIsStripe(currentPaymentMethod), [
    currentPaymentMethod,
  ]);
  const isTranzila = useMemo(() => checkIsTranzila(currentPaymentMethod), [
    currentPaymentMethod,
  ]);

  const convenienceFee = useMemo(() => {
    if (!currentPaymentMethod) return 0;

    const shouldApplyConvenienceFee =
      currentPaymentMethod.coverConvenienceFee &&
      convenienceFeeByPayment[activePayment];

    if (!shouldApplyConvenienceFee) return 0;

    const baseForCF = totalPay?.total - donationAmount;
    return calcConvenienceFee(currentPaymentMethod?.convenienceFeeInfo, baseForCF);
  }, [currentPaymentMethod, totalPay, donationAmount, convenienceFeeByPayment, activePayment]);

  const totalPaymentWithCVFee =
    formik?.values?.activePayment === "bill-my-account"
      ? totalPay?.total
      : +totalPay?.total + +convenienceFee;

  const dueAmountConvenienceFee = useCallback(
    (totalDueAmount) => {
      if (!currentPaymentMethod) return 0;
      const shouldApplyConvenienceFee =
        currentPaymentMethod.coverConvenienceFee &&
        convenienceFeeByPayment[activePayment];

      if (!shouldApplyConvenienceFee) return 0;
      return calcConvenienceFee(
        currentPaymentMethod?.convenienceFeeInfo,
        totalDueAmount,
      );
    },
    [currentPaymentMethod, convenienceFeeByPayment, activePayment],
  );

  const calculateAmount = (items, type = "ticket") => {
    return items.reduce((total, item) => {
      const installmentValue =
        item?.installmentStatus && item?.installment?.value;
      const itemAmount =
        type === "ticket"
          ? item?.amount * item?.selectedQuantity
          : item?.amount;
      return (
        total + (installmentValue ? itemAmount / installmentValue : itemAmount)
      );
    }, 0);
  };
  const calculateDueAmount = useCallback(() => {
    // Full addon total (before any installment reduction) for Payment Total display
    const fullAddonTotal = newProducts.reduce((sum, p) => sum + (p.amount || 0), 0);
    const totalProductAmount = calculateAmount(newProducts, "product");

    let baseTicketAmount = 0;
    let fullTicketTotal = 0;

    if (eventData?.multiEventsType === "individual") {
      const onRegPrice = eventData?.eventPricing?.prices?.find(
        (p) => p?.type === "onRegistration" && p?.variant
      );
      const rawVariantInfo = onRegPrice?.variantInfo || {};
      const hasMultiDateVariants = Object.values(rawVariantInfo).some((v) => v?.eventDate);
      if (hasMultiDateVariants) {
        const multiDateVariantTotal = (selectedVariants || []).reduce((sum, ticketVarMap) => {
          return sum + Object.values(ticketVarMap || {}).reduce((tSum, variantKey) => {
            if (variantKey === null || variantKey === undefined) return tSum;
            return tSum + (rawVariantInfo[variantKey]?.amount || 0);
          }, 0);
        }, 0);
        fullTicketTotal = multiDateVariantTotal;
        // Apply installment reduction to the multi-date variant total, consistent with group event handling
        const onRegTicketVariant = ticketTypeVariants?.find(
          (v) => v.installmentStatus && v.installment?.value
        );
        baseTicketAmount = onRegTicketVariant
          ? multiDateVariantTotal / onRegTicketVariant.installment.value
          : multiDateVariantTotal;
      } else {
        const selectedDates = selectedEventDates || [];
        const dateTotal = selectedDates.reduce((sum, ticketDates) => {
          if (!Array.isArray(ticketDates)) return sum;
          return sum + ticketDates.reduce((tSum, dateIdx) => {
            return tSum + (eventData?.multiEventsDates?.[dateIdx]?.amount || 0);
          }, 0);
        }, 0);
        fullTicketTotal = dateTotal;
        baseTicketAmount = dateTotal;
      }
    } else {
      baseTicketAmount = calculateAmount(ticketTypeVariants, "ticket");
      fullTicketTotal = (ticketTypeVariants || []).reduce(
        (sum, item) => sum + (item.amount || 0) * (item.selectedQuantity || 0),
        0
      );
    }

    const {
      totalAfterDiscount,
      discountTotal,
    } = calculation.calculateDueDiscount(
      baseTicketAmount,
      eventData?.eventDiscount,
      numberOfTickets,
      isAuth,
    );
    const baseAmount = totalProductAmount + totalAfterDiscount;
    const convenienceFeeAmount = dueAmountConvenienceFee(baseAmount);
    const { totalAfterDiscount: fullTicketAfterDiscount } = calculation.calculateDueDiscount(
      fullTicketTotal,
      eventData?.eventDiscount,
      numberOfTickets,
      isAuth,
    );
    const appliedDiscount = fullTicketTotal - fullTicketAfterDiscount;
    const fullAfterDiscount = fullTicketAfterDiscount + fullAddonTotal;
    const fullCF = dueAmountConvenienceFee(fullAfterDiscount);
    const fullPaymentTotal = fullAfterDiscount + fullCF;
    return {
      totalDueAmount: baseAmount + donationAmount,
      dueAmountCF: convenienceFeeAmount,
      totalDueAmountWithCF: baseAmount + convenienceFeeAmount + donationAmount,
      dueAmountTotalDiscount: discountTotal,
      appliedDiscount,
      fullPaymentTotal,
    };
  }, [ticketTypeVariants, newProducts, dueAmountConvenienceFee, selectedVariants, selectedEventDates, eventData, donationAmount]);

  const updatedFormDataWithDatePicker = (id, formDataItem) => {
    return formDataItem;
  };

  const updatedTicketData = (ticket) => {
    const currentTicket = ticketTypeVariants?.find(
      (item) => item.name?.toLowerCase() === ticket?.title?.toLowerCase(),
    );
    const hasInstallment = currentTicket?.installmentStatus;
    return {
      ...ticket,
      ...(hasInstallment
        ? { numberOfInstallments: currentTicket?.installment?.value }
        : {}),
    };
  };

  const updatedProductsData = (products) => {
    return products.map((product) => {
      const currentProduct = newProducts?.find(
        (item) => item.title?.toLowerCase() === product?.title?.toLowerCase(),
      );
      const hasInstallment = currentProduct?.installmentStatus;

      // varients is keyed by index; each entry has an `id` matching the product id
      const varientEntry = Object.values(varients || {}).find(
        (v) => v?.id === product?.id,
      );

      // varientEntry exists only for addon products (type optional/openAmount)
      const isAddon = !!varientEntry;

      let updatedVariant = product.variant;
      if (product.variant && typeof product.variant === "object") {
        updatedVariant = Object.fromEntries(
          Object.entries(product.variant).map(([key, val]) => {
            const variantOption = varientEntry?.variantsInfo?.find(
              (vi) => vi.option === key,
            );
            if (variantOption?.openAmount) return [key, val];
            if (isAddon) return [key, val?.quantity ?? val];
            const { price: _price, ...rest } = val || {};
            return [key, rest];
          }),
        );
      }

      return {
        ...product,
        variant: updatedVariant,
        ...(hasInstallment
          ? { numberOfInstallments: currentProduct?.installment?.value }
          : {}),
      };
    });
  };

  const ConvertFormToFormData = (data) => {
    const dataArray = [...data];
    if (dataArray[0] !== undefined) {
      // TODO: Replace map with forEach since there is nothing returned from the map
      const formDataArray = dataArray.map((dataItem, dataIndex) => {
        const { id, formData: formDataItem, products, ticket } = dataItem;
        // ? Check if this is in use; if not, consider deleting it.
        const updatedFormData = updatedFormDataWithDatePicker(id, formDataItem);
        const updatedTicket = updatedTicketData(ticket);
        const updatedProducts = updatedProductsData(products);

        formData.append(
          `registrationForm[${dataIndex}][formData]`,
          JSON.stringify([...updatedFormData]),
        );
        formData.append(`registrationForm[${dataIndex}][id]`, `${id}`);
        formData.append(
          `registrationForm[${dataIndex}][products]`,
          JSON.stringify([...updatedProducts]),
        );
        if (!eventData?.freeEvent) {
          const onRegPrice = eventData?.multiEventsType === "individual"
            ? eventData?.eventPricing?.prices?.find(
                (p) => p?.type === "onRegistration" && p?.variant,
              )
            : null;
          const ticketToSend = onRegPrice?._id
            ? { ...updatedTicket, id: onRegPrice._id }
            : updatedTicket;
          formData.append(
            `registrationForm[${dataIndex}][ticket]`,
            JSON.stringify(ticketToSend),
          );
        }

        // Build eventsDates for this participant
        if (eventData?.multiEvents) {
          let eventsDates = [];
          const isGroup = eventData?.multiEventsType === "grouped";
          const isIndividual = eventData?.multiEventsType === "individual";

          if (isGroup) {
            // Grouped: send all event dates
            eventsDates = (eventData?.multiEventsDates || []).map((d) => ({
              date: d?.eventDate,
              name: d?.label || d?.name || d?.variantName || "",
              label: d?.label || d?.name || d?.variantName || "",
            }));
          } else if (isIndividual) {
            const onRegPrice = eventData?.eventPricing?.prices?.find(
              (p) => p?.type === "onRegistration" && p?.variant,
            );
            const rawVariantInfo = onRegPrice?.variantInfo || {};
            const hasMultiDateVariants = Object.values(rawVariantInfo).some(
              (v) => v?.eventDate,
            );

            if (hasMultiDateVariants) {
              // Variant-based: get selected variant per day slot
              const ticketVarMap =
                (selectedVariants || [])[dataIndex] || {};
              Object.entries(ticketVarMap).forEach(([, variantKey]) => {
                if (variantKey !== null && variantKey !== undefined && rawVariantInfo[variantKey]) {
                  const variantData = rawVariantInfo[variantKey];
                  eventsDates.push({
                    date: variantData?.eventDate || "",
                    name: variantKey,
                    label: variantData?.dateLabel || "",
                    ...(variantData?.variantLabel ? { variant: variantData.variantLabel } : {}),
                  });
                }
              });
            } else {
              // Date-index based: send only the dates the participant selected
              const selectedIdxs =
                (selectedEventDates || [])[dataIndex] || [];
              selectedIdxs.forEach((idx) => {
                const d = (eventData?.multiEventsDates || [])[idx];
                if (d) {
                  eventsDates.push({
                    date: d?.eventDate,
                    name: d?.label || d?.name || d?.variantName || "",
                    label: d?.label || d?.name || d?.variantName || "",
                    ...(d?.variantName ? { variant: d.variantName } : {}),
                  });
                }
              });
            }
          }

          formData.append(
            `registrationForm[${dataIndex}][eventsDates]`,
            JSON.stringify(eventsDates),
          );
        }

        // ? Check if this is in use; if not, consider deleting it.
        const formDataObj = formDataItem?.forEach((dataItem) => {
          if (dataItem?.name?.includes("file_upload")) {
            if (dataItem?.value && dataItem?.value !== null) {
              formData.append(
                `registrationForm[${dataIndex}][files][${id}]`,
                dataItem?.value,
              );
            }
          }
        });
      });
    }
  };
  const handleDataForTwoFlow = (tokenId = "", coverFee = true, tranzilaChargeResult = null) => {
    formData.append(`isMember`, isAuth ? true : false);
    if (!isAuth) {
      formData.append(`orgId`, localStorage.getItem("eventOrgId"));
    }
    formData.append(`eventId`, params?.id);
    formData.append(`reservationId`, reservationId);
    formData.append("coverFee", coverFee);
    const objectName = "cardsDetails";
    const objectData = formik?.values?.cardsDetails;
    if (formik?.values?.activePayment === "credit-card") {
      formData.append("paymentMethodId", paymentMethod?._id);
      if (isAuth) {
        formData.append("cardId", selectedCard);
      } else if (tranzilaChargeResult) {
        // Payment already done in Tranzila iframe — pass result, skip card fields
        formData.append("tranzilaChargeResult", JSON.stringify(tranzilaChargeResult));
      } else if (tokenId) {
        formData.append("token", tokenId);
      } else {
        for (const key in objectData) {
          if (key === "expiry") {
            formData.append(
              `${objectName}[exp_month]`,
              objectData[key]?.split("/")[0],
            );
            formData.append(
              `${objectName}[exp_year]`,
              objectData[key]?.split("/")[1],
            );
          } else if (key === "card_number") {
            formData.append(`${objectName}[number]`, objectData[key]);
          } else {
            formData.append(`${objectName}[${key}]`, objectData[key]);
          }
        }
      }
    } else if (formik?.values?.activePayment === "ach") {
      formData.append("paymentMethodId", achPaymentMethod?._id);
      if (isAuth) {
        formData.append("cardId", selectedAchCard);
      }
    } else {
      const currentTotal = handleTotalForPay();
      const hasAmountDue = currentTotal?.total !== "0.00" || totalProducts > 0;
      formData.append(`billMyAccount`, hasAmountDue);
    }
    // Checkout donation
    if (donationAmount > 0 && checkoutDonationLedger) {
      formData.append("checkoutDonation[ledger_id]", checkoutDonationLedger._id || checkoutDonationLedger.ledger_id || "");
      formData.append("checkoutDonation[ledger_name]", checkoutDonationLedger.ledger_name || "");
      formData.append("checkoutDonation[amount]", donationAmount);
      if (checkoutDonationLedger.account_receivable) {
        formData.append("checkoutDonation[account_receivable]", checkoutDonationLedger.account_receivable);
      }
    }
    // Account Info
    if (isAuth) return;
    const objectName2 = "accountInfo";
    const objectData2 = formik?.values?.accountInfo;
    for (const key in objectData2) {
      if (key === "addresses") {
        const objeLocation = formik.values?.accountInfo?.addresses[0].location;
        if (Object.keys(objeLocation).length !== 0) {
          formik.values?.accountInfo?.addresses[0].location?.formattedAddress &&
            formData.append(
              `${objectName2}[addresses][0][location][formattedAddress]`,
              formik.values?.accountInfo?.addresses[0].location
                ?.formattedAddress,
            );
          formik.values?.accountInfo?.addresses[0].location?.place_id &&
            formData.append(
              `${objectName2}[addresses][0][location][place_id]`,
              formik.values?.accountInfo?.addresses[0].location?.place_id,
            );
          formik.values?.accountInfo?.addresses[0]?.city &&
            formData.append(
              `${objectName2}[addresses][0][city]`,
              formik.values?.accountInfo?.addresses[0]?.city,
            );
          formik.values?.accountInfo?.addresses[0]?.state &&
            formData.append(
              `${objectName2}[addresses][0][state]`,
              formik.values?.accountInfo?.addresses[0]?.state,
            );
          formik.values?.accountInfo?.addresses[0]?.zip_code &&
            formData.append(
              `${objectName2}[addresses][0][zip_code]`,
              formik.values?.accountInfo?.addresses[0]?.zip_code,
            );
          formik.values?.accountInfo?.addresses[0]?.addressLine2 &&
            formData.append(
              `${objectName2}[addresses][0][addressLine2]`,
              formik.values?.accountInfo?.addresses[0]?.addressLine2,
            );
        }
      } else {
        formData.append(`${objectName2}[${key}]`, objectData2[key]);
      }
    }
  };

  // get stripe token
  const handleGetStripeToken = async () => {
    const tokenId = await addCardStripeRef?.current?.handleGetToken();
    if (tokenId && tokenId !== null && token !== undefined) {
      return tokenId;
    }
    return "";
  };

  const isValidInstallment = () => {
    const prices = ticketTypeVariants;
    let isValid = true;
    const products = newProducts.forEach((item) => {
      if (item?.installmentStatus && !item?.installment?.value) {
        isValid = false;
      }
    });
    const tickets = prices?.forEach((item) => {
      if (item?.installmentStatus && !item?.installment?.value) {
        isValid = false;
      }
    });
    return isValid;
  };

  // Api For Pay
  // Called when Tranzila iframe completes payment for unauthenticated users
  const handleTranzilaCharged = async (result) => {
    // Validate required registration fields before completing the registration.
    // The Tranzila iframe fires this callback after the card charge, so we must
    // check here to prevent a registration record being created with missing data.
    if (thereIsFormEmpty) {
      return enqueueSnackbar(
        "You have errors in filling out the form, please check them",
        { variant: "error" },
      );
    }
    const requiredFields = FormDataEvent;
    const dataValidation = formik?.values?.registrationForm?.map((item, index) => ({
      ...item,
      formData: item?.formData
        ?.map((subItem, subItemIndex) => {
          const required = requiredFields?.find(
            (r) => r.id === subItem.id && r.required,
          );
          if (subItem?.name?.includes("date_picker") && required) {
            const el = document.querySelector(`[name="${subItem.name}"]`);
            return {
              errorMessage:
                !el?.value ? `The ${required?.label} is required` : "",
            };
          }
          if (subItem?.name?.includes("file_upload") && required) {
            return {
              errorMessage:
                !subItem.value?.name ? `The ${required?.label} is required` : "",
            };
          }
          if (subItem.value && subItem?.value?.length > 0) {
            if (subItem?.name?.includes("email_input")) {
              return {
                errorMessage: emailRegex.test(subItem.value)
                  ? ""
                  : `Please enter valid email for (${requiredFields[subItemIndex]?.label}) field`,
              };
            }
            return { errorMessage: "" };
          }
          if (required) {
            return { errorMessage: `The ${required.label} is required` };
          }
          return { errorMessage: "" };
        })
        .filter((e) => e.errorMessage !== ""),
    }));
    formik.setFieldValue("errors", dataValidation);
    const allErrorsEmpty = dataValidation.every(
      (item) => item.formData.length === 0,
    );
    if (!allErrorsEmpty) {
      return enqueueSnackbar(
        "You have errors in filling out the form, please check them",
        { variant: "error" },
      );
    }

    handleDataForTwoFlow("", true, result);
    ConvertFormToFormData(formDataReservation);
    setLoadingPay(true);
    try {
      const token = localStorage.getItem("eventToken");
      await EvevntService.createParticipant(token, formData);
      formik.setFieldValue("resultPage", "success");
    } catch (err) {
      enqueueSnackbar(err?.data?.message || "Payment failed, please try again", { variant: "error" });
    } finally {
      setLoadingPay(false);
    }
  };

  const PayNow = async (hasStripe) => {
    const isFreeEvent = handleTotalForPay()?.total === "0.00" && totalProducts <= 0;
    if (!formik?.values?.activePayment && !isFreeEvent) return;
    const captchaValue = recaptchaRef?.current?.getValue();
    if (
      !captchaValue &&
      !isAuth &&
      (totalPay?.total !== "0.00" || totalProducts > 0)
    )
      return enqueueSnackbar("Please verify the captcha", {
        variant: "info",
      });
    if (isLoadingPay) return;
    const thereIsFormEmpty = formDataReservation?.some(
      (item) => item?.formData?.length === 0,
    );
    if (thereIsFormEmpty) {
      enqueueSnackbar(
        "You have errors in filling out the form , please check them",
        {
          variant: "error",
        },
      );
    } else {
      const requiredFields = FormDataEvent;
      const dataValidation = formik?.values?.registrationForm?.map(
        (item, index) => {
          return {
            ...item,
            formData: item?.formData
              ?.map((subItem, subItemIndex) => {
                const requireds = requiredFields?.find(
                  (tofinditem) =>
                    tofinditem.id === subItem.id && tofinditem.required,
                );
                if (
                  subItem?.name.includes("date_picker") &&
                  requireds !== undefined
                ) {
                  const datePickerField = document.querySelector(
                    `#${item?.id} input[name="${subItem.name}"]`,
                  );
                  if (
                    datePickerField &&
                    (!datePickerField?.value ||
                      datePickerField?.value === undefined)
                  ) {
                    return {
                      errorMessage: `The ${requireds?.label} is required`,
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }

                if (
                  subItem?.name.includes("file_upload") &&
                  requireds !== undefined
                ) {
                  if (
                    !subItem.value?.name ||
                    subItem.value?.name === undefined
                  ) {
                    return {
                      errorMessage: `The ${requireds?.label} is required`,
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }
                if (subItem.value && subItem?.value?.length > 0) {
                  if (subItem?.name.includes("email_input")) {
                    return {
                      errorMessage: emailRegex.test(subItem.value)
                        ? ""
                        : `Please enter valid email for (${requiredFields[subItemIndex]?.label}) field`,
                    };
                  }
                  if (subItem?.name.includes("phone_input")) {
                    const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                    return {
                      errorMessage: phoneRegex.test(subItem.value)
                        ? ""
                        : `Please enter valid Phone Number for (${requiredFields[subItemIndex]?.label}) field`,
                    };
                  } else {
                    return { errorMessage: "" };
                  }
                }
                if (requireds !== undefined) {
                  return { errorMessage: `The ${requireds.label} is required` };
                } else {
                  return { errorMessage: "" };
                }
              })
              .filter((element) => element.errorMessage !== ""),
          };
        },
      );
      formik.setFieldValue("errors", dataValidation);
      const allErrorsEmpty = dataValidation.every(
        (item) => item.formData.length === 0,
      );

      if (allErrorsEmpty) {
        // Validate that every ticket has at least one event date selected
        if (ticketsMissingDates.length > 0) {
          return enqueueSnackbar(
            `Ticket${ticketsMissingDates.length > 1 ? "s" : ""} #${ticketsMissingDates.join(", #")} must each have at least one event date selected`,
            { variant: "error" }
          );
        }

        const validInstallment = isValidInstallment();
        if (!validInstallment) {
          return enqueueSnackbar("Please select number of installments", {
            variant: "info",
          });
        }
        const validZipCode = postalCodeFormat(
          formik?.values?.cardsDetails?.zip,
        );
        if (
          !isStripe &&
          formik?.values?.cardsDetails?.zip?.length &&
          !validZipCode &&
          formik?.values?.activePayment === "credit-card" &&
          !isAuth
        ) {
          enqueueSnackbar(`Invalid ${postalLabel}`, { variant: "info" });
        }
        let tokenId = "";
        if (
          isStripe &&
          formik?.values?.activePayment === "credit-card" &&
          !isAuth
        ) {
          tokenId = await handleGetStripeToken();
        }

        if (
          isAuth &&
          !selectedCard &&
          formik?.values?.activePayment === "credit-card" &&
          (totalPay?.total !== "0.00" || totalProducts > 0)
        ) {
          enqueueSnackbar("Please select a credit card", { variant: "error" });
          return;
        }

        if (
          isAuth &&
          !selectedAchCard &&
          formik?.values?.activePayment === "ach" &&
          (totalPay?.total !== "0.00" || totalProducts > 0)
        ) {
          enqueueSnackbar("Please select an ACH card", { variant: "error" });
          return;
        }

        if (
          (hasStripe && tokenId) ||
          !hasStripe ||
          formik?.values?.activePayment === "bill-my-account" ||
          (isAuth && selectedCard) ||
          (isAuth && selectedAchCard)
        ) {
          handleDataForTwoFlow(
            tokenId || "",
            convenienceFeeByPayment[activePayment],
          );
          ConvertFormToFormData(formDataReservation);
          if (error?.message) {
            enqueueSnackbar(error?.message, {
              variant: "error",
            });
            setLoadingPay(false);
          } else {
            setLoadingPay(true);
            try {
              const token = isAuth
                ? await getAccessTokenSilently()
                : localStorage.getItem("eventToken");
              await EvevntService.createParticipant(token, formData).then(
                (res) => {
                  formik.setFieldValue("resultPage", "success");
                },
              );
            } catch (error) {
              const message = error?.data?.message
                ? error?.data?.message
                : "There is somthing wrong";
              enqueueSnackbar(message, {
                variant: "error",
              });
            } finally {
              setLoadingPay(false);
            }
          }
        }
      } else {
        enqueueSnackbar(
          "You have errors in filling out the form , please check them",
          {
            variant: "error",
          },
        );
      }
    }
  };

  useEffect(() => {
    const fetchCheckoutDonationLedger = async () => {
      try {
        const orgToken = isAuth
          ? await getAccessTokenSilently()
          : localStorage.getItem("eventToken");
        const orgId = localStorage.getItem("eventOrgId");
        const res = await FinanceService.getCheckoutDonationLedger(orgToken, orgId);
        if (res?.ledger) setCheckoutDonationLedger(res.ledger);
      } catch (_) {} finally {
        setIsLoadingDonationLedger(false);
      }
    };
    fetchCheckoutDonationLedger();
  }, []);

  useEffect(() => {
    if (
      Object.keys(eventData).length !== 0 &&
      !eventData?.allowNonMembers &&
      !isAuthenticated
    ) {
      history.push(`/events/${params?.id}`);
    } else {
      if (isAuth) {
        setTimeout(() => {
          const accountDetails = JSON.parse(
            localStorage.getItem("accountInfo"),
          );
          formik.setFieldValue("accountInfo", {
            first_name: accountDetails?.firstName ?? "",
            last_name: accountDetails?.lastName ?? "",
            primary_email_address: accountDetails?.primary_email_address ?? "",
          });
        }, 2000);
      }
      if (Object.keys(eventData).length !== 0) {
        const preserve = !isInitialFormLoad.current;
        isInitialFormLoad.current = false;
        getFormById(preserve);
      }
    }
  }, [eventData, isAuth]);

  useEffect(() => {
    formik.setFieldValue("cardsDetails", formik.values?.cardsDetails);
    if (!isAuth) {
      formik.setFieldValue("accountInfo", formik.values?.accountInfo);
    }
    let keysWithoutData = [];
    if (formDataReservation?.length === 0) {
      numberOfTickets.map((ticketId) => {
        const ticketType = ticketTypeList?.find((item) => item.id === ticketId);
        keysWithoutData.push({
          id: ticketId,
          formData: [],
          products: [],
          ticket: ticketType
            ? {
                id: eventData?.multiEventsType === "individual"
                  ? (eventData?.eventPricing?.prices?.find(
                      (p) => p?.type === "onRegistration" && p?.variant,
                    )?._id || ticketType.ticketId)
                  : ticketType.ticketId,
                title: ticketType.name,
              }
            : {},
        });
      });
      formik.setFieldValue("registrationForm", keysWithoutData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, numberOfTickets, isAuth, formDataReservation]);


  const resetReservation = () => {
    formik.setFieldValue(
      "ticketsData",
      Array.from({ length: numberOfTickets?.length }, () => [...products]),
    );
    dispatch(
      eventsSlice.actions.setVarients(
        JSON.parse(localStorage.getItem("originVarients")),
      ),
    );
  };

  const handleLogout = () => {
    formik.setFieldValue("accountInfo", {});
    formik.setFieldValue("activePayment", "credit-card");
    resetReservation();
    localStorage.clear();
    toastr.success("Success", "Successfully Logged out!");
    window.location.href = `/events/${params?.id}`;
  };

  const setActivePaymentAfter = useCallback(() => {
    if (!isAuth) return formik.setFieldValue("activePayment", "credit-card");
    const activePayment = formik.values?.activePayment;
    if (
      paymentMethod?.allowMemberInstallment &&
      achPaymentMethod?.allowMemberInstallment
    ) {
      if (activePayment === "bill-my-account") {
        formik.setFieldValue("activePayment", "credit-card");
      }
      return;
    }

    const nextPayment = paymentMethod?.allowMemberInstallment
      ? "credit-card"
      : achPaymentMethod?.allowMemberInstallment
      ? "ach"
      : null;

    if (nextPayment) {
      formik.setFieldValue("activePayment", nextPayment);
    }
  }, [paymentMethod, achPaymentMethod, formik.values?.activePayment]);

  const {
    totalDueAmount,
    dueAmountCF,
    totalDueAmountWithCF,
    dueAmountTotalDiscount,
    appliedDiscount,
    fullPaymentTotal,
  } = calculateDueAmount();

  const effectiveTotalPaymentWithCVFee =
    eventData?.multiEventsType === "individual"
      ? fullPaymentTotal
      : totalPaymentWithCVFee;

  const displayTicketName = (ticket, index) => {
    if (!ticket || eventData?.freeEvent)
      return `Ticket #${index + 1} Information`;
    return `${
      ticket?.name?.toLowerCase() === "ticket" ? "" : ticket?.name
    } Ticket #${index + 1} Information`;
  };

  const onDeleteTicket = (tab, index) => {
    setConfirmDeleteTicket({
      open: true,
      ticketId: tab?.id,
      ticketIndex: index,
      isLoading: false,
    });
  };
  const closeConfirmDeleteTicket = () => {
    setConfirmDeleteTicket({
      open: false,
      ticketId: null,
      ticketIndex: null,
      isLoading: false,
    });
  };

  const handleDeleteProducts = (ticketIndex, index) => {
    const removeTicket = numberOfTickets.filter((num) => num !== ticketIndex);
    dispatch(setCounterTicket(removeTicket));

    const findSelectedVariant = ticketTypeList?.find(
      (item) => item.id === ticketIndex,
    );

    if (findSelectedVariant) {
      const updatedTicketTypeVariants = ticketTypeVariants.map((item) => {
        if (item?.name === findSelectedVariant?.name) {
          return { ...item, selectedQuantity: item.selectedQuantity - 1 };
        } else {
          return { ...item };
        }
      });
      dispatch(setTicketTypeVariants(updatedTicketTypeVariants));
    }

    const filteredTicketTypeList = ticketTypeList.filter(
      (local) => local.id !== ticketIndex,
    );
    dispatch(setTicketTypeList(filteredTicketTypeList));
    setTicketTypeTabs((prev) => prev.filter((item) => item.id !== ticketIndex));

    const filteredTickets = formik.values.registrationForm?.filter(
      (local) => local.id !== ticketIndex,
    );
    const filteredTicketsData = formik.values.ticketsData?.filter((local) => {
      return formik.values.ticketsData.indexOf(local) !== index;
    });
    formik.setFieldValue("ticketsData", filteredTicketsData);
    formik.setFieldValue("registrationForm", filteredTickets);
    setSelectedVariants((prev) => prev.filter((_, i) => i !== index));
    setSelectedEventDates((prev) => prev.filter((_, i) => i !== index));
    // Reduce the counterValue from varients depend on number on selected values
    if (selectedValue && selectedValue.length > 0) {
      const productsData = formik.values.ticketsData[index];

      const updatedData = { ...varients };
      const NewVarientsData = Object.keys(updatedData).map((key) => {
        const selectedArray = selectedValue[0][updatedData[key]?.varientTitle];
        const selectedTicket = selectedArray?.[0]?.ticketIndex === ticketIndex;
        if (selectedArray && selectedTicket) {
          if (updatedData[key]?.variantsInfo?.length === 0) {
            return {
              ...updatedData[key],
              counterValue:
                updatedData[key]?.counterValue - selectedArray[0]?.value,
            };
          } else {
            const varientInfo = updatedData[key]?.variantsInfo?.map(
              (varInfo) => {
                const findSelectedValue = selectedArray.find(
                  (val) =>
                    val.value === varInfo.option &&
                    val.ticketIndex === ticketIndex,
                );
                if (findSelectedValue && findSelectedValue !== undefined) {
                  return {
                    ...varInfo,
                    counterValue:
                      varInfo.counterValue > 0 ? varInfo.counterValue - 1 : 0,
                  };
                } else {
                  return { ...varInfo };
                }
              },
            );
            const dropDown =
              updatedData[key]?.id === productsData[key]?._id
                ? updatedData[key]?.numberOfDrops -
                  productsData[key]?.dropdowns?.length
                : updatedData[key]?.numberOfDrops;
            return {
              ...updatedData[key],
              numberOfDrops: dropDown,
              variantsInfo: varientInfo,
            };
          }
        } else {
          return { ...updatedData[key] };
        }
      });
      dispatch(eventsSlice.actions.setVarients(NewVarientsData));

      const updatedForm = {};
      const form = selectedValue[0];
      for (const key in form) {
        updatedForm[key] = form[key].filter(
          (item) => item.ticketIndex !== ticketIndex,
        );
      }

      const filteredData = Object.fromEntries(
        Object.entries(updatedForm).filter(([k, v]) => v.length > 0),
      );
      const finalData =
        Object.keys(filteredData)?.length > 0 ? [filteredData] : [];
      dispatch(
        eventsSlice.actions.setSelectedValue({
          data: finalData,
          productIndex: index,
          productTitle: products[index]?.title,
          dropdownIndex: selectedValue[0]?.[products[index]?.title]?.length - 1,
          type: "remove",
        }),
      );
    }
  };
  const handleDeleteTicket = async () => {
    setConfirmDeleteTicket((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const body = {
      reservationId,
    };
    try {
      const token = localStorage.getItem("eventToken");
      await EvevntService.deleteTicket(token, body).then((res) => {
        closeConfirmDeleteTicket();
        if (activeTicket === confirmDeleteTicket?.ticketIndex) {
          setActiveTicket(0);
        }
        handleDeleteProducts(
          confirmDeleteTicket?.ticketId,
          confirmDeleteTicket?.ticketIndex,
        );
      });
    } catch (error) {
      if (error?.data?.message) {
        enqueueSnackbar(error?.data?.message, {
          variant: "error",
        });
      }
      throw error;
    } finally {
      setConfirmDeleteTicket((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };

  const checkFormDataValidation = useCallback(
    (ticketId, formData) => {
      const ticketData = formData?.find((item) => item.id === ticketId);
      if (ticketData?.formData?.length === 0) return;
      const allFormFields = FormDataEvent;
      const requiredFields = allFormFields?.filter(
        (item) => item.required === true,
      );
      const isFormValid = requiredFields?.every((item) => {
        const formField = ticketData?.formData?.find(
          (field) => field.id === item.id,
        );
        return (
          formField?.value &&
          formField?.value !== null &&
          formField?.value !== undefined
        );
      });
      const currentTab = ticketTypeTabs?.findIndex(
        (item) => item.id === ticketId,
      );
      const updatedTicketTypeTabs = ticketTypeTabs?.map((item, index) => {
        if (index === currentTab) {
          return { ...item, valid: isFormValid };
        }
        return item;
      });
      setTicketTypeTabs(updatedTicketTypeTabs);
    },
    [ticketTypeTabs, FormDataEvent],
  );

  const checkDisabledSubmit = useCallback(() => {
    const isDisable = ticketTypeTabs?.some((item) => !item.valid);
    if (isDisable) return true;

    const ticketCount = ticketTypeList?.length || 1;
    const hasEmptyRequiredAddon = products?.some((product) => {
      if (product?.type !== "optional" || !product?.isRequired) return false;
      const variant = Object.values(varients || {}).find(
        (v) => v.id === product._id,
      );
      if (!variant) return true;
      if (variant.variantsInfo?.length > 0) {
        const totalSelected = variant.variantsInfo.reduce(
          (sum, v) => sum + (v.counterValue || 0),
          0,
        );
        return totalSelected < ticketCount;
      }
      return (variant.counterValue || 0) < ticketCount;
    });
    return hasEmptyRequiredAddon;
  }, [ticketTypeTabs, ticketTypeList, products, varients]);

  const updateTicketAfterAppliedCheckBox = () => {
    const updatedTicketTypeTabs = ticketTypeTabs?.map((item, index) => {
      if (index === 0) return item;
      return { ...item, valid: true };
    });
    setTicketTypeTabs(updatedTicketTypeTabs);
  };

  return (
    <>
      {formik.values?.resultPage !== "" ? (
        <PaymentResultPage
          result={formik.values?.resultPage}
          formik={formik}
          isTherePayment={totalPay?.total !== "0.00" || totalProducts > 0}
          showThanksMsg={
            formik.values?.activePayment === "bill-my-account" &&
            (totalPay?.total !== "0.00" || totalProducts > 0)
          }
          eventData={eventData}
          selectedVariants={selectedVariants}
          selectedEventDates={selectedEventDates}
        />
      ) : (
        <>
          <Header Logo={logo} showTimer={true} />
          <Wrapper>
            <Grid
              container
              spacing={2}
              sx={{ width: "100%" }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={!makeEventFormsFullScreen ? 12 : 7}
                direction="column"
              >
                <Paper
                  sx={{
                    height: isMobile ? "165px" : "227px",
                    borderRadius: "10px",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "#1A2027" : "#2555EF",
                  }}
                >
                  <ImageContainer isMobile={isMobile}>
                    <CardContent isMobile={isMobile}>
                      <h1>{eventData?.eventName}</h1>
                    </CardContent>
                    <div>
                      <ImageCard src={CardImage} alt="bg" isMobile={isMobile} />
                    </div>
                  </ImageContainer>
                </Paper>
                <ReservationTabs
                  tabs={ticketTypeTabs}
                  displayTabLabel={displayTicketName}
                  onTabsChange={(index) => {
                    setActiveTicket(index);
                  }}
                  activeTab={activeTicket}
                  onDeleteTab={onDeleteTicket}
                />
                {activeTicket !== undefined && ticketTypeList?.length > 0 && (
                  <>
                    <Ticket
                      key={`ticket_${isCheckedApplay}`}
                      index={activeTicket}
                      formik={formik}
                      ticketUniqueId={ticketTypeList[activeTicket]?.id}
                      setIsCheckedApplay={setIsCheckedApplay}
                      isCheckedApplay={isCheckedApplay}
                      totalProducts={totalProducts}
                      handleTotalForPay={handleTotalForPay}
                      checkFormDataValidation={checkFormDataValidation}
                      updateTicketAfterAppliedCheckBox={
                        updateTicketAfterAppliedCheckBox
                      }
                      selectedEventDates={selectedEventDates}
                      setSelectedEventDates={setSelectedEventDates}
                      selectedVariants={selectedVariants}
                      setSelectedVariants={setSelectedVariants}
                    />
                    <br />
                  </>
                )}
                {/* {numberOfTickets?.map((item, index) => (
                  <>
                    <Ticket
                      key={`ticket_${isCheckedApplay}`}
                      index={index}
                      formik={formik}
                      ticketUniqueId={item}
                      setIsCheckedApplay={setIsCheckedApplay}
                      isCheckedApplay={isCheckedApplay}
                      totalProducts={totalProducts}
                      handleTotalForPay={handleTotalForPay}
                    />
                    <br />
                  </>
                ))} */}
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={5} direction="column">
                <SummaryCard
                  handleTotalForPay={handleTotalForPay}
                  totalPaymentWithCVFee={effectiveTotalPaymentWithCVFee}
                  billMyAccount={
                    formik?.values?.activePayment === "bill-my-account"
                  }
                  newProducts={newProducts}
                  setProducts={setProducts}
                  dueAmountCF={dueAmountCF}
                  totalDueAmountWithCF={totalDueAmountWithCF}
                  totalDiscount={appliedDiscount}
                  dueAmountTotalDiscount={dueAmountTotalDiscount}
                  totalDueAmount={totalDueAmount}
                  isInstallmentEnabled={isInstallmentEnabled}
                  setActivePaymentAfter={setActivePaymentAfter}
                  activePayment={activePayment}
                  convenienceFeeByPayment={convenienceFeeByPayment}
                  setConvenienceFeeByPayment={setConvenienceFeeByPayment}
                  currentPaymentMethod={currentPaymentMethod}
                  selectedEventDates={selectedEventDates}
                  selectedVariants={selectedVariants}
                  onCalcDueAmountChange={setCalcDueAmount}
                  formDataReservation={formDataReservation}
                  ticketsData={formik.values.ticketsData}
                  productsOpenAmount={formik.values.productsOpenAmount}
                  donationAmount={donationAmount}
                />

                <PersonalDetailsCard
                  formik={formik}
                  isLoadingPay={isLoadingPay}
                  PayNow={PayNow}
                  error={error}
                  setError={setError}
                  handleTotalForPay={handleTotalForPay}
                  totalProducts={totalProducts}
                  isTherePayment={makeEventFormsFullScreen}
                  showZipCode={!isAuth}
                  isAuthenticated={isAuth}
                  handleLogout={handleLogout}
                  onOpenLoginModal={() => setLoginModalOpen(true)}
                />
                <LoginModal
                  open={loginModalOpen}
                  onClose={() => setLoginModalOpen(false)}
                  onSuccess={(accountInfo) => {
                    setLoginModalOpen(false);
                    setAuthTick((t) => t + 1);
                    if (accountInfo?.first_name) {
                      formik.setFieldValue("accountInfo.first_name", accountInfo.first_name);
                      formik.setFieldValue("accountInfo.last_name", accountInfo.last_name);
                      formik.setFieldValue("accountInfo.primary_email_address", accountInfo.primary_email_address);
                    }
                  }}
                />

                {formik?.values?.activePayment !== "bill-my-account" && (
                  <DonationBox
                    ledger={checkoutDonationLedger}
                    loading={isLoadingDonationLedger}
                    onDonationChange={(amount, ledger) => { setDonationAmount(amount); if (ledger) setCheckoutDonationLedger(ledger); }}
                  />
                )}

                <PaymentCard
                  TotalForPay={totalProducts}
                  formik={formik}
                  setError={setError}
                  error={error}
                  PayNow={PayNow}
                  isLoadingPay={isLoadingPay}
                  handleTotalForPay={handleTotalForPay}
                  setLoadingPay={setLoadingPay}
                  isStripe={isStripe}
                  isTranzila={isTranzila}
                  currentPaymentMethod={currentPaymentMethod}
                  addCardStripeRef={addCardStripeRef}
                  isAuthenticated={isAuth}
                  setSelectedCard={setSelectedCard}
                  selectedCard={selectedCard}
                  setSelectedAchCard={setSelectedAchCard}
                  selectedAchCard={selectedAchCard}
                  totalDueAmountWithCF={calcDueAmount !== null ? calcDueAmount : totalDueAmountWithCF}
                  totalDueAmount={totalDueAmount}
                  recaptchaRef={recaptchaRef}
                  enableCreditCardPay={enableCreditCardPay}
                  enableAchPay={enableAchPay}
                  disabledAchPay={disabledAchPay}
                  displayAchTooltip={displayAchTooltip}
                  disabledCreditCardPay={disabledCreditCardPay}
                  disabledBillMyAccount={disabledBillMyAccount}
                  enableBillMyAccount={enableBillMyAccount}
                  publicKey={
                    currentPaymentMethod?.paymentGateway?.keys?.publicKey
                  }
                  checkDisabledSubmit={checkDisabledSubmit}
                  onTranzilaCharged={handleTranzilaCharged}
                  orgId={localStorage.getItem("eventOrgId")}
                  isRegistrationReady={isRegistrationFormValid}
                />
              </Grid>
            </Grid>

            <ContactUs eventData={eventData} />
          </Wrapper>
          {handleTotalForPay()?.total === "0.00" && totalProducts <= 0 && (
            <Grid item xs={12}>
              <PaymentButtonSubmit isDisabled={thereIsFormEmpty}>
                <button
                  disabled={thereIsFormEmpty}
                  onClick={() => {
                    PayNow();
                  }}
                >
                  {isLoadingPay ? (
                    <ClipLoader
                      color={"#ffffff"}
                      loading={isLoadingPay}
                      size={32}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </PaymentButtonSubmit>
            </Grid>
          )}
        </>
      )}
      <AlertDialog
        open={confirmDeleteTicket.open}
        handleClose={closeConfirmDeleteTicket}
        onDecline={closeConfirmDeleteTicket}
        onAccept={handleDeleteTicket}
        isLoading={confirmDeleteTicket.isLoading}
        content={
          <div className="alert-message-popup">
            <p className="alert-icon">{/* <DeleteForeverIcon /> */}</p>
            <div>
              <p>Delete Ticket</p>
              <p className="alert-message">
                Are you sure you want to remove this ticket?
              </p>
            </div>
          </div>
        }
      />
    </>
  );
};
